// Novo arquivo para o componente dos termos
export const TermosPrivacidade = () => {
    return (
        <div class="max-w-3xl mx-auto p-6 bg-white mt-10">
        
        <section class="mb-6">
            <h2 class="text-xl font-semibold text-gray-700 mb-2">1. Permissões</h2>
            <ul class="list-disc list-inside text-gray-600">
                <li>Acessar seu calendário Google</li>
                <li>Visualizar eventos existentes</li>
                <li>Criar novos eventos em seu nome</li>
                <li>Atualizar eventos existentes</li>
                <li>Excluir eventos criados pela integração</li>
            </ul>
        </section>
        
        <section class="mb-6">
            <h2 class="text-xl font-semibold text-gray-700 mb-2">2. Uso dos Dados</h2>
            <ul class="list-disc list-inside text-gray-600">
                <li>Sincronização de agendamentos</li>
                <li>Gerenciamento de disponibilidade</li>
                <li>Notificações de compromissos</li>
                <li>Relatórios e análises de compromissos</li>
            </ul>
        </section>
        
        <section class="mb-6">
            <h2 class="text-xl font-semibold text-gray-700 mb-2">3. Segurança e Privacidade</h2>
            <ul class="list-disc list-inside text-gray-600">
                <li>Protegemos suas informações pessoais</li>
                <li>Não compartilhamos seus dados com terceiros</li>
                <li>Seus dados são mantidos seguros e criptografados</li>
                <li>Você pode revogar o acesso a qualquer momento</li>
            </ul>
        </section>
        
        <section class="mb-6">
            <h2 class="text-xl font-semibold text-gray-700 mb-2">4. Consentimento e Controle do Usuário</h2>
            <ul class="list-disc list-inside text-gray-600">
                <li>Ao conectar sua conta, você concorda com esses termos</li>
                <li>Gerencie suas permissões no Google</li>
                <li>Entre em contato conosco para suporte</li>
            </ul>
        </section>

    </div>
    );
}; 